import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="grid-bg min-h-[calc(100vh-73px)] flex items-center">
      <div className="max-w-xl mx-auto w-full px-6">
        <div className="card-surface p-10 text-center" data-testid="payment-cancel-card">
          <XCircle className="mx-auto text-zinc-500 mb-4" size={48} />
          <h1 className="font-display font-extrabold text-3xl tracking-tighter mb-2">
            Checkout cancelled
          </h1>
          <p className="text-zinc-400 text-sm mb-8">
            No worries — nothing was charged. Jump back in whenever you're ready.
          </p>
          <div className="flex items-center justify-center gap-3">
            <Link to="/wallet" className="btn-bid text-sm">
              Back to packs
            </Link>
            <Link to="/" className="btn-outline text-sm">
              Browse auctions
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
